import { render, staticRenderFns } from "./Subtitles.vue?vue&type=template&id=61ef90b9"
import script from "./Subtitles.vue?vue&type=script&lang=js"
export * from "./Subtitles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports